import Vue from 'vue'
import { makeQueryStringDync, errorServeiceHandler } from '../helper'
const state = {
    graphsData: undefined,
    lowerGraphsData: undefined
};

const getters = {
    getgraphsData: (state) => {
        return state.graphsData;
    },
    getlowerGraphsData: (state) => {
        console.log("getters " , state);
        return state.lowerGraphsData;
    }
};

const mutations = {
    setgraphsData: (state, data) => {
        console.log("mutation ",data);
        state.graphsData = data;
    },
    setlowerGraphsData: (state, data) => {
        state.lowerGraphsData = data;
    }
};

const actions = {
    getMqStat: (context,payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('mqstats'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/mqstats' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                localStorage.setItem("mqstats",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                reject(error);
            });
        });
    },
    getCredit: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('credits'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            // fetch(context.getters.baseUrl + '/lco/v1/stat/credits' + queryStr, {
            fetch(context.getters.baseUrl + '/lco/v1/stat/creditdetails', {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                localStorage.setItem("credits",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                if (context.getters.getMode == "development") {

                    resolve(
                    //     {
                    //     "total": 10479637.34,
                    //     "day": {
                    //         "PENDING": 10,
                    //         "PAID": 20,
                    //         "FAILED": 30
                    //     },
                    //     "oneweek": {
                    //         "PENDING": 0,
                    //         "PAID": "1",
                    //         "FAILED": 0
                    //     },
                    //     "twoweek": {
                    //         "PENDING": 0,
                    //         "PAID": "1",
                    //         "FAILED": 0
                    //     },
                    //     "month": {
                    //         "PENDING": "15",
                    //         "PAID": "5",
                    //         "FAILED": 0
                    //     }
                    // },
                    {
                        "today": [
                            {
                                "type": "DCREFUND",
                                "totalamount": "50021.00"
                            },
                            {
                                "type": "CASHBACK",
                                "totalamount": null
                            },
                            {
                                "type": "TOPUP",
                                "totalamount": "21.00"
                            }
                        ],
                        "yesterday": [
                            {
                                "type": "DCREFUND",
                                "totalamount": null
                            },
                            {
                                "type": "CASHBACK",
                                "totalamount": "11.4"
                            },
                            {
                                "type": "TOPUP",
                                "totalamount": "200.2"
                            }
                        ],
                        "week": [
                            {
                                "type": "DCREFUND",
                                "totalamount": "2.61"
                            },
                            {
                                "type": "CASHBACK",
                                "totalamount": "1.00"
                            },
                            {
                                "type": "TOPUP",
                                "totalamount": "3.00"
                            }
                        ],
                        "month": [
                            {
                                "type": "DCREFUND",
                                "totalamount": "2.61"
                            },
                            {
                                "type": "CASHBACK",
                                "totalamount": "11.00"
                            },
                            {
                                "type": "TOPUP",
                                "totalamount": "7.00"
                            }
                        ],
                        "totalcredit": [
                            {
                                "amount": "7.00"
                            }
                        ],
                        "totalcashback": [
                            {
                                "amount": "13.61"
                            }
                        ],
                        "totalamount": [
                            {
                                "amount": "12806902.89"
                            }
                        ]
                    }
                );
                  }
                reject(error);
            });
        });
    },
    getRenew: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('mqexpiry'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/expiry' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                return response.json()
            }).then((data) => {
                localStorage.setItem("mqexpiry",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                
                reject(error);
            });
        });
    },
    getRevenues: (context, payload) => {
        return new Promise( (resolve, reject) => {
            // let graphData = JSON.parse(localStorage.getItem('revenues'))
            // if (graphData) {
            //     if (Object.keys(graphData).length) {
            //     resolve(graphData)
            //     return
            //     }
            // }
            let queryStr = makeQueryStringDync(payload)
            fetch(context.getters.baseUrl + '/lco/v1/stat/revenues' + queryStr, {
            method: 'GET'
           })
           .then(errorServeiceHandler)
           .then((response) => {
                 return response.json()
            }).then((data) => {
                localStorage.setItem("revenues",JSON.stringify(data))
                resolve(data)
                //type CLK DLK
            }).catch((error) => {
                reject(error);
            });
        });
    },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboardModule.js